import { Component, input } from '@angular/core';
import { CommonMessageWidget } from '@eforall/common';

@Component({
	selector: 'readonly-access',
	standalone: true,
	imports: [CommonMessageWidget],
	templateUrl: './readonly-access.widget.html',
	styleUrls: ['./readonly-access.widget.scss'],
})
export class ReadonlyAccessWidget {

	public readonly = input.required<boolean>();

}